module.exports = __webpack_public_path__ + "static/media/bed.9a715da6.svg";